/**
 * CARE4 – microinterações globais (leve, sem bibliotecas):
 * 1. Estado "rolado" do header (body.c4-scrolled): header mais baixo e sólido.
 * 2. Mega menu abre ao passar o mouse no computador (clique continua funcionando).
 * 3. Elementos das seções da CARE4 aparecem suavemente ao entrar na tela.
 */
(function () {
  var body = document.body;

  // 1. Header ao rolar. Na home acompanha a logo grande do hero, que volta
  // para o header a partir de 80px (sections/care4-hero.liquid).
  var threshold = body.classList.contains('c4-page-index') ? 80 : 8;
  var ticking = false;
  function updateScrolled() {
    ticking = false;
    body.classList.toggle('c4-scrolled', window.scrollY > threshold);
  }
  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateScrolled);
      }
    },
    { passive: true }
  );
  updateScrolled();

  // 2. Mega menu no hover (só em telas com mouse)
  var canHover = window.matchMedia('(hover: hover) and (min-width: 990px)');
  document.querySelectorAll('.c4-header details.mega-menu').forEach(function (details) {
    var closeTimer;
    details.addEventListener('mouseenter', function () {
      if (!canHover.matches) return;
      clearTimeout(closeTimer);
      if (!details.open) details.querySelector('summary').click();
    });
    details.addEventListener('mouseleave', function () {
      if (!canHover.matches) return;
      closeTimer = setTimeout(function () {
        if (details.open) details.querySelector('summary').click();
      }, 160);
    });
  });

  // 2b. Compra rápida "+" nos cards (snippets/card-product.liquid).
  // O "+" abre os tamanhos em cima da foto; tocar num tamanho adiciona ao
  // carrinho e abre o carrinho lateral. Produto de tamanho único adiciona direto.
  function closeAllSizes(except) {
    document.querySelectorAll('[data-c4-qa].is-open').forEach(function (qa) {
      if (qa === except) return;
      qa.classList.remove('is-open');
      var sizes = qa.querySelector('.c4-qa__sizes');
      if (sizes) sizes.hidden = true;
      var toggle = qa.querySelector('.c4-qa__toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function quickAdd(button) {
    var qa = button.closest('[data-c4-qa]');
    var cart = document.querySelector('cart-drawer');
    var sectionIds = cart && cart.getSectionsToRender ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [];
    qa.classList.add('is-loading');
    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: Number(button.dataset.variantId),
        quantity: 1,
        sections: sectionIds,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        qa.classList.remove('is-loading');
        closeAllSizes();
        if (data.status) {
          // Erro da loja (ex.: sem estoque): mostra a mensagem no próprio card
          qa.setAttribute('data-error', data.description || data.message || '');
          setTimeout(function () { qa.removeAttribute('data-error'); }, 3000);
          return;
        }
        if (cart && cart.renderContents) {
          cart.classList.remove('is-empty');
          cart.renderContents(data);
        } else {
          window.location.href = window.routes.cart_url;
        }
      })
      .catch(function () {
        qa.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('.c4-qa__toggle, .c4-qa__size');
    if (!target) {
      if (!event.target.closest || !event.target.closest('[data-c4-qa]')) closeAllSizes();
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    var qa = target.closest('[data-c4-qa]');

    if (target.classList.contains('c4-qa__size') || target.dataset.variantId) {
      quickAdd(target);
      return;
    }

    var sizes = qa.querySelector('.c4-qa__sizes');
    var opening = !qa.classList.contains('is-open');
    closeAllSizes(qa);
    qa.classList.toggle('is-open', opening);
    sizes.hidden = !opening;
    target.setAttribute('aria-expanded', String(opening));
  });

  // 3. Aparecer ao rolar
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce.matches || !('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) return;

  var targets = document.querySelectorAll(
    '.c4-category, .c4-grid__item, .c4-mosaic__item, .c4-gallery__item, .c4-editorial__text, .c4-statement > *, .c4-section-head'
  );
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px' }
  );
  targets.forEach(function (el, i) {
    el.classList.add('c4-reveal');
    // Itens lado a lado entram em sequência curta, não todos de uma vez
    el.style.transitionDelay = (i % 4) * 60 + 'ms';
    observer.observe(el);
  });
})();
